module.exports = __webpack_public_path__ + "assets/advantages-wallet-4f6b1b.svg";